import { getServiceWorkerRegistration } from './serviceWorker';

/**
 * Проверка поддержки Push API
 */
export function isPushSupported(): boolean {
  return (
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window
  );
}

/**
 * Запрос разрешения на уведомления
 */
export async function requestNotificationPermission(): Promise<NotificationPermission> {
  if (!('Notification' in window)) {
    return 'denied';
  }

  if (Notification.permission === 'granted') {
    return 'granted';
  }

  if (Notification.permission === 'denied') {
    return 'denied';
  }

  const permission = await Notification.requestPermission();
  return permission;
}

/**
 * Получение push-подписки от браузера
 */
export async function getPushSubscription(
  registration: ServiceWorkerRegistration,
  publicKey: string
): Promise<PushSubscription | null> {
  try {
    // Проверяем существующую подписку
    let subscription = await registration.pushManager.getSubscription();

    if (!subscription) {
      // Создаем новую подписку
      const keyArray = urlBase64ToUint8Array(publicKey);
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: keyArray as unknown as ArrayBuffer,
      });
    }

    return subscription;
  } catch (error) {
    console.error('[Push] Ошибка получения подписки:', error);
    return null;
  }
}

/**
 * Конвертация VAPID ключа из base64 в Uint8Array
 */
function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

/**
 * Проверка статуса подписки
 */
export async function checkSubscriptionStatus(): Promise<{
  isSubscribed: boolean;
  subscription: PushSubscription | null;
}> {
  try {
    const registration = await getServiceWorkerRegistration();
    if (!registration) {
      return {
        isSubscribed: false,
        subscription: null,
      };
    }

    const subscription = await registration.pushManager.getSubscription();
    
    return {
      isSubscribed: !!subscription,
      subscription,
    };
  } catch (error) {
    console.error('[Push] Ошибка проверки статуса:', error);
    return {
      isSubscribed: false,
      subscription: null,
    };
  }
}

/**
 * Обработка ошибок подписки
 */
export function handleSubscriptionError(error: any): string {
  if (error.name === 'NotAllowedError') {
    return 'Разрешение на уведомления было отклонено. Разрешите уведомления в настройках браузера.';
  }
  
  if (error.name === 'NotSupportedError') {
    return 'Push-уведомления не поддерживаются в этом браузере.';
  }
  
  if (error.name === 'InvalidStateError') {
    return 'Подписка уже существует или была удалена.';
  }
  
  if (error.name === 'AbortError') {
    return 'Операция была прервана.';
  }
  
  return `Ошибка: ${error.message || 'Неизвестная ошибка'}`;
}

